export default class TextHelper {
  public static stripHTML(text: string): string {
    const html = text?.replace(/<br\s*[/]?>/gi, ' ');
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
  }

  public static isURL(url: string): boolean {
    const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
    return regexp.test(url);
  }
}
